import { baseBackend } from "../../../../../api/base/baseUrl";

export async function getDriverMethodCollectingRequest(driverId) {
  return baseBackend.get(`/api/v2/method-collecting/driver/${driverId}`);
}

export async function getMethodCollectingCatalogRequest() {
  return baseBackend.get("/api/v2/method-collecting");
}

export async function createDriverMethodCollectingRequest(data) {
  return baseBackend.post("/api/v2/method-collecting/driver", data);
}

export async function updateDriverMethodCollectingRequest(data) {
  return baseBackend.put("/api/v2/method-collecting/driver", data);
}
